import {css, view} from '@sail/ui/deprecated';

export const AvatarSpacer = () => <view.div css={{width: css.value('28px')}} />;
